import React from "react";
import { BsChevronLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
function BtnBack({ to = -1, text = "Back" }) {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(to);
  };

  return (
    <h5
      className="btn-back-text my-auto text-decoration-none"
      style={{ color: "var(--color-on-base-content-high)" }}
    >
      <BsChevronLeft onClick={goBack} className="me-1 shrink-0 pointer-event" />
      <span className="btn-back-text-label">{text}</span>
    </h5>
  );
}

export default BtnBack;
